import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cn } from "@/lib/utils.ts";

function Avatar({ className, size = "default", ...props }: React.ComponentProps<typeof AvatarPrimitive.Root> & { size?: "sm" | "default" | "lg" }) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      data-size={size}
      className={cn("relative flex shrink-0 overflow-hidden rounded-full data-[size=sm]:size-6 data-[size=default]:size-8 data-[size=lg]:size-12", className)}
      {...props}
    />
  );
}

function AvatarImage({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return <AvatarPrimitive.Image data-slot="avatar-image" className={cn("aspect-square size-full object-cover", className)} {...props} />;
}

function AvatarFallback({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return <AvatarPrimitive.Fallback data-slot="avatar-fallback" className={cn("flex size-full items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary uppercase", className)} {...props} />;
}

export { Avatar, AvatarFallback, AvatarImage };
